import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Ribbon from "@/components/site/Ribbon";
import About from "@/components/site/About";
import Services from "@/components/site/Services";
import Projects from "@/components/site/Projects";
import Contact from "@/components/site/Contact";

export default function App() {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 1 });
        window.__lenis = lenis;
        let raf;
        const loop = (t) => {
            lenis.raf(t);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <div className="bg-paper text-ink font-body antialiased">
            <div className="grain" aria-hidden="true" />
            <Nav />
            <main>
                <Hero />
                <Ribbon />
                <About />
                <Services />
                <Projects />
                <Contact />
            </main>
        </div>
    );
}
